<template>
  <common-template>
        <div class="list">
            <h1 class="title d-flex border-bottom inner">{{ $t(pageTitle) }}</h1>
            <div class="search inner">
              <div class="title accordion d-flex justify-content-between align-items-center" id="accordionDrawing-header" data-toggle="collapse" data-target=".accordionDrawing" aria-controls="searchContent searchButton">
                <h2>{{ $t("検索条件") }}</h2>
                <div class="accordion-toggle-btn">
                  <b-button block id="accordionDrawing-up">{{ $t('閉じる') }}</b-button>
                  <b-button block id="accordionDrawing-down">{{ $t('開く') }}</b-button>
                </div>
              </div>
              <div id="searchContent" class="accordionDrawing content collapse" aria-labelledby="accordionDrawing-header">
                <div class="d-flex flex-row">
                  <div class="m-3 d-flex flex-row align-items-center justify-content-start form-group">
                    <label for="search-status" class="label">{{ $t("工場") }}:&nbsp;</label>
                    <select class="custom-select select" id="id_factory" v-model="form.site">
                      <option selected></option>
                      <template v-for="(item ,index) in mixinSpacesListDisplay('site')" :keyed="`site-${index}`">
                        <option :value="item.id" :key="`site-${index}`">{{ item.name }}</option>
                      </template>
                    </select>
                    <label for="search-status" class="label ml-3">{{ $t("部署") }}:&nbsp;</label>
                    <select name="factory" class="input form-control" id="id_department" v-model="form.dep">
                      <option value=""></option>
                      <template v-for="(item ,index) in mixinSpacesListDisplay('dep')" :keyed="`dep-${index}`">
                        <option :value="item.id" :key="`dep-${index}`">{{ item.name }}</option>
                      </template>
                    </select>
                  </div>
                </div>
              </div>
            <div id="searchButton" class="button accordionDrawing collapse">
              <button class="btn btn-info" @click="handleSearchUser()">
                {{ $t("検索") }}
              </button>
            </div>
          </div>
          <div class="inner d-flex justify-content-end mt-4 mb-4">
            <button type="button" class="btn btn-success create-btn" @click="createModalOpenRegist()">
              {{ $t("登録") }}
          </button>
        </div>
        <div class="table-list inner">
          <h2 class="title">{{ $t("検索結果") }}</h2>
            <div class="content">
              <table class="table table-bordered">
                <thead class="thead">
                  <tr>
                    <th width="150" scope="col">{{ $t("表示順") }}</th>
                    <th width="150" scope="col">{{ $t("工場") }}</th>
                    <th width="150" scope="col">{{ $t("部署") }}</th>
                    <th width="150" scope="col">{{ $t("氏名") }}</th>
                    <th width="150" scope="col">{{ $t("ログインID") }}</th>
                    <th width="180" scope="col">{{ $t("権限") }}</th>
                    <th width="100" scope="col"></th>
                    <th width="180" scope="col"></th>
                    <th width="210" scope="col"></th>
                    <th width="100" scope="col"></th>
                  </tr>
                </thead>
                <tbody class="tbody">
                  <template v-if="!load && this.list.length">
                    <tr v-for="(item, index) in this.list" :key="index">
                      <td>{{ item.sort }}</td>
                      <td>{{ mixinSpacesDisplay(item.spaces.site) }}</td>
                      <td>{{ mixinSpacesDisplay(item.spaces.dep) }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.loginId }}</td>
                      <!-- <td class="text-right">{{ item.hourPrice | mixinNumberFormatDisplay}}</td> -->
                      <td>{{ mixinPrivilegeDisplay(item.privilege) }}</td>
                      <td><button type="button" class="btn-light btn"
                        @click="createModalOpenEdit(item)">{{ $t("編集") }}</button></td>
                      <td><button type="button" class="btn-success btn"
                        @click="assignedModalOpen(item)">{{ $t("担当工程登録") }}</button></td>
                      <td><button type="button" class="btn-light btn btn-sm" style="font-size:12px"
                        @click="passwordReset(item)">{{ $t("パスワードリセット") }}</button></td>
                      <td><template v-if="userId != item.id"><button type="button" class="btn-danger btn" @click="deleteAlert(item)">{{ $t("削除") }}</button></template></td>
                    </tr>
                  </template>
                  <template v-else-if="!load && !this.list.length">
                    <tr>
                      <td rowspan="2" colspan="99" class="text-center">
                        {{ $t("ノーデータメッセージ") }}
                      </td>
                    </tr>
                  </template>
                  <template v-else-if="load">
                    <tr>
                      <td colspan="12">
                        <div class="d-flex justify-content-center m-5" v-if="load">
                          <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
          <paginate
           v-model="mixinCurrentPage"
           :page-count="mixinGetPageCount"
           :force-page="mixinGetForcePage"
           :page-range="3"
           :margin-pages="1"
           :click-handler="handlePageChanged"
           :prev-text="'«'"
           :next-text="'»'"
           :container-class="'pagination justify-content-end'"
           :page-class="'page-item'"
           :page-link-class="'page-link'"
           :prev-class="'page-item'"
           :prev-link-class="'page-link'"
           :next-class="'page-item'"
           :next-link-class="'page-link'"
           ref="page"
          ></paginate>
          <create-modal
            ref="createModal"
            :isUpdate="isUpdate"
            @registed="init()"
          ></create-modal>
          <assigned-modal
            ref="assignedModalOpen"
            @registed="init()"
          ></assigned-modal>
      </div>
  </common-template>
</template>

<script>
import searchHelper from '../../mixin/search-helper'
import assignedModal from './assignedRegistrationModal'
import createModal from './createModal'

import { mapGetters } from 'vuex'

export default {
  mixins: [searchHelper],
  data() {
    return {
      list: [],
      form: {
        site: null,
        dep: null,
      },
      workTimes: {
        'workTime1': this.$t('シフト1'),
        'workTime2': this.$t('シフト2'),
        'workTime3': this.$t('シフト3'),
      },
      master: {},
      load: false,
      userId: '',
      pageTitle: '担当者情報一覧',
      isUpdate: false,
    }
  },
  components: {
    createModal,
    assignedModal,
  },
  updated() {
    document.title = this.$t(this.pageTitle)
  },
  async created() {
    this.load = true
    try {
      await this.$store.dispatch('auth/user')
    } catch (err) {
      this.$toasted.show(this.$t('データ取得エラーメッセージ'))
    } finally {
      this.load = false
    }
    await this.getMasterData()
    await this.loaddCurrentUser()
    await this.searchUsers()
  },
  methods: {
    async init() {
      await this.searchUsers()
    },
    async getMasterData() {
      try {
        this.master = []
        const res = await this.$axios.get(`${this.$appConfig.CommonApiUrl}/masters`, {
          headers: {
            'Authorization': this.authorization ? this.authorization : null,
          },
        })
        this.master = res.data
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    },
    async loaddCurrentUser() {
      try {
        this.userId = ''
        const res = await this.$axios.get(`${this.$appConfig.CommonApiUrl}/user`, {
          headers: {
            'Authorization': this.authorization ? this.authorization : null,
          },
        })
        this.userId = res.data.id
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    },
    async searchUsers(isSearch = true) {
      let params = {}
      if (isSearch) {
        if (this.form.site) params.site = this.form.site
        if (this.form.dep) params.dep = this.form.dep
      }
      try {
        this.load = true
        this.list = []
        let headers = {
            'Authorization': this.authorization ? this.authorization : null,
        }
        const res = await this.mixinGetPageList(`${this.$appConfig.CommonApiUrl}/users`, params, headers)
        this.list = res
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      } finally {
        this.load = false
      }
    },
    createModalOpen(item = {}) {
      this.$refs.createModal.createModalOpen(item)
    },
    createModalOpenEdit(item = {}) {
      this.isUpdate = true
      this.createModalOpen(item)
    },
    createModalOpenRegist(item = {}) {
      this.isUpdate = false
      this.createModalOpen(item)
    },
    assignedModalOpen(item = {}) {
      this.$refs.assignedModalOpen.modalOpen(item)
    },
    async passwordReset(item) {

      const confirm = await this.$swal({
        text: this.$t(`${item.name}のパスワードリセットします`),
        className: 'swal-none',
        buttons: {
          cancel: {
            text: this.$t('キャンセル'),
            value: null,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            value: true,
            visible: true,
            className: '',
            closeModal: false,
          },
        },
        dangerMode: true,
      })
      if (confirm) {
        try {
          await this.$axios.post(
            `${this.$appConfig.CommonApiUrl}/user/password/reset`,
            { id: item.id, companyId: this.master.company ? this.master.company.id ? this.master.company.id : 0 : 0 },
            {
              headers: {
                Authorization: this.authorization ? this.authorization : null,
              },
            }
          )
          this.$swal.close()
          this.$toasted.success(this.$t('パスワードリセットのメールを送信しました。'))
          this.init()
        } catch (err) {
          console.log(err)
          this.$swal.close()
          this.$toasted.show(this.$t('データ受付エラーメッセージ'))
        }
      }
    },
    async deleteAlert(item) {
      const confirm = await this.$swal({
        text: this.$t(`${item.name}`) + this.$t('削除確認メッセージ'),
        className: 'swal-none',
        buttons: {
          cancel: {
            text: this.$t('キャンセル'),
            value: null,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            value: true,
            visible: true,
            className: '',
            closeModal: false,
          },
        },
        dangerMode: true,
      })
      if (confirm) {
        try {
          // await this.$axios.put(
          //   `${this.$appConfig.CommonApiUrl}/user`,
          //   { id: item.id, cognitoUId: item.cognitoUId, isDelete: true, },
          //   {
          //     headers: {
          //       Authorization: this.authorization ? this.authorization : null,
          //     },
          //   }
          // )
          await this.$axios.delete(
            `${this.$appConfig.CommonApiUrl}/user`,
            {
              params: {id: item.id},
              headers: {
                Authorization: this.authorization ? this.authorization : null,
              },
            }
          )
          this.$swal.close()
          this.$toasted.success(this.$t('データ削除完了メッセージ'))
          this.init()
        } catch (err) {
          console.log(err)
          this.$toasted.show(this.$t('データ削除エラーメッセージ'))
        }
      }
    },
    getWorkTimeName(item) {
      if (item.workTime) {
        return this.workTimes[item.workTime]
      }
      return ''
    },
    async handlePageChanged(pageNum) {
      this.mixinSetPageNumber(pageNum)
      await this.searchUsers(false)
    },
    async handleSearchUser() {
      this.mixinSetPageNumber(1)
      await this.searchUsers(true)
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
      userdata: 'auth/userdata',
    }),
  },
}
</script>

<style lang="scss" scoped>
</style>
